import { render, staticRenderFns } from "./VPoliciesSummary.vue?vue&type=template&id=41dbe366"
import script from "./VPoliciesSummary.vue?vue&type=script&lang=js"
export * from "./VPoliciesSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports